// extracted by mini-css-extract-plugin
export default {"content":"CloudAccountPage_content__A2a0q","summaryTables":"CloudAccountPage_summaryTables__vGnzD"};